import React from 'react';
interface ImagePlaceholderProps {
  name: string;
  className?: string;
}
export function ImagePlaceholder({
  name,
  className = ''
}: ImagePlaceholderProps) {
  return <div className={`flex flex-col items-center justify-center bg-card border border-dashed border-gold/50 rounded-lg p-6 text-center ${className}`} data-id="element-253">
      <div className="text-gold mb-2" data-id="element-254">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-255">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" data-id="element-256" />
          <circle cx="9" cy="9" r="2" data-id="element-257" />
          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" data-id="element-258" />
        </svg>
      </div>
      <span className="text-sm text-gray font-medium mb-1" data-id="element-259">
        Espacio para imagen:
      </span>
      <span className="text-white font-bold text-sm bg-primary px-3 py-1 rounded-full border border-border" data-id="element-260">
        {name}
      </span>
    </div>;
}